import Vue from "vue";

let isLoaded = false;
let loadingPromise = null;

export const loadVueTour = async () => {
  if (isLoaded) return;

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = Promise.all([
    import("vue-tour"),
    import("vue-tour/dist/vue-tour.css"),
  ])
    .then(([module]) => {
      Vue.use(module.default);

      isLoaded = true;
    })
    .catch((e) => {
      loadingPromise = null;
      throw e;
    });

  return loadingPromise;
};
